import React, { Component } from "react";
import "./SingleSelectCheckBox.scss";

const SOCIETY_MASTER_SINGLE_CHECKBOX_STYLES = {
  padding: 0,
  alignItems: "center",
};

const SOCIETY_MASTER_SINGLE_CHECKBOX_LABEL_STYLES = { paddingLeft: "0.5rem" };

export default class SingleSelectCheckBox extends Component {
  handleSelection = (val) => {
    let isSelected =
      this.props.selected && this.props.selected.includes(val.value)
        ? true
        : false;
    if (this.props.onSelect) {
      this.props.onSelect(isSelected ? null : val.value);
    }
  };
  render() {
    return (
      <div>
        <div styleName={"single-base"}>
          {this.props.options &&
            this.props.options.map((val, i) => {
              return (
                <div
                  styleName={"single-row"}
                  key={i}
                  style={{
                    width: this.props.rowWidth,
                    ...(this.props?.societyMasterSingleCheckboxRowStyles
                      ? SOCIETY_MASTER_SINGLE_CHECKBOX_STYLES
                      : {}),
                  }}>
                  <div
                    styleName={
                      this.props.selected &&
                      this.props.selected.length > 0 &&
                      this.props.selected.includes(val.value)
                        ? `button-active${
                            this.props?.roundedCheckBox ? " rounded" : ""
                          }${this.props?.disabled ? " disabled" : ""}`
                        : `button${
                            this.props?.roundedCheckBox ? " rounded" : ""
                          }${this.props?.disabled ? " disabled" : ""}`
                    }
                    onClick={() => {
                      !this.props.disabled && this.handleSelection(val);
                    }}
                    tabIndex={this.props.tabIndex ? this.props.tabIndex : "0"}
                    onKeyUp={(e) =>
                      e.key === "Enter" &&
                      !this.props.disabled &&
                      this.handleSelection(val)
                    }></div>
                  {!this.props.hideLabel && (
                    <div
                      styleName={"label"}
                      style={{
                        color: this.props.color,
                        fontSize: this.props.fontSize,
                        cursor: this.props.disabled ? "default" : "pointer",
                        ...(this.props?.societyMasterSingleCheckboxLabelStyles
                          ? SOCIETY_MASTER_SINGLE_CHECKBOX_LABEL_STYLES
                          : {}),
                      }}
                      onClick={() => {
                        !this.props.disabled && this.handleSelection(val);
                      }}>
                      {val.label}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
        {this.props.error && <div styleName={"error"}>{this.props.error}</div>}
      </div>
    );
  }
}
